export const licitaciones2025 = [
  {
    titulo: "CONVOCATORIA 01-2025",
    subtitulo: [
      {
        informacionTitulo: "EA-913005999-N1-2025",
      },
      {
        informacionTitulo: "EA-913005999-N2-2025",
      },
    ],
  },
  {
    titulo: "CONVOCATORIA 01-2025 OBRA",
    subtitulo: [
      {
        informacionTitulo: "CAASIM-HGO-L.O.P.-01-2025",
      },
    ]
  }
];